export default __webpack_public_path__ + "static/media/Q6_4.b9d21ed8.png";